import React from 'react';
import '../styles/Button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLElement> {
	children: React.ReactNode;
	variant?: string;
}

export const Button: React.FC<ButtonProps> = ({ children, className = '', variant, ...props }) => {
	const variantClass = variant ? `btn-${variant}` : '';

	return (
		<button
			{...props}
			className={`luquid-function-button liquid-button liquidGlass-wrapper menu ${variantClass} ${className}`.trim()}
		>
			<div className="liquidGlass-effect"></div>
			<div className="liquidGlass-tint"></div>
			<div className="liquidGlass-shine"></div>
			<div className="liquidGlass-text">
				{children}
			</div>
		</button>
	);

};